
import React, { memo, useState, useEffect, useCallback } from 'react';
import cx from 'classnames';
import _isEmpty from 'lodash.isempty';
import { formatDate } from '@shootsta/get-moment';
import { List, Text, ActionPopup, Checkbox } from '../../../../../ui-kit';
import AssetPreview from '../../../../AssetPreview';
import { getAssetPreviewProps } from '../utils';
import '../styles/_asset-list-card.scss';













function AssetsListCard({
  item,
  options,
  handleClick,
  isProjectBrief,
  handleAddToProjectBriefClick,
  selectedDrawerItemIds,
  selectedAssetIds = [],
  onMenuClose,
  isBulkSelected = false
}) {
  const { title, createdAt, createdByUser, assetId, assetFiles, metaData } = item;
  // Seed from drawer so selection survives card unmount on tag change.
  const [checked, setChecked] = useState(() =>
    Boolean(isProjectBrief && selectedDrawerItemIds?.includes(assetId))
  );
  const [enableCheckbox, setEnableCheckbox] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const wrapperRef = React.useRef(null);

  useEffect(() => {
    if (isProjectBrief && enableCheckbox) {
      const { THUMBNAIL, ORIGINAL } = assetFiles;
      const meta = JSON.parse(metaData);
      let assetType = 'other';
      if (meta !== null) {
        const { type } = meta;
        const [t] = type.split('/');
        assetType = t;
      }
      const itemBriefData = {
        id: assetId,
        checkedState: checked,
        thumbnail: !_isEmpty(THUMBNAIL) ? THUMBNAIL : ORIGINAL,
        assetType
      };
      handleAddToProjectBriefClick(itemBriefData);
    }
    setEnableCheckbox(true);
  }, [checked]);

  useEffect(() => {
    // Determine if asset should be checked as part of project brief
    // Assets can be selected/deselected from elsewhere
    if (isProjectBrief && enableCheckbox) {
      if (selectedDrawerItemIds.length === 0) setChecked(false);
      const isInDrawer = selectedDrawerItemIds.includes(assetId);
      setChecked(isInDrawer);
    }
  }, [selectedDrawerItemIds]);

  const handleDragStart = useCallback((e) => {
    // If this asset is part of a multi-selection, drag all selected assets
    const isInSelection = selectedAssetIds.includes(assetId);
    const dragIds = isInSelection && selectedAssetIds.length > 1 ?
    selectedAssetIds :
    [assetId];

    e.dataTransfer.setData('application/json', JSON.stringify({ assetIds: dragIds }));
    e.dataTransfer.effectAllowed = 'copy';

    // Custom drag image — compact badge with asset count
    const count = dragIds.length;
    const badge = document.createElement('div');
    badge.textContent = `${count} asset${count > 1 ? 's' : ''}`;
    badge.style.cssText = 'position:fixed;top:-100px;left:-100px;padding:6px 14px;border-radius:6px;background:#27baa1;color:#fff;font-size:13px;font-weight:600;white-space:nowrap;pointer-events:none;z-index:9999;display:flex;align-items:center;gap:6px;box-shadow:0 2px 8px rgba(0,0,0,0.15);';
    const { body } = document;
    if (body) {
      body.appendChild(badge);
      e.dataTransfer.setDragImage(badge, 0, 0);
      setTimeout(() => {if (badge.parentNode) badge.parentNode.removeChild(badge);}, 0);
    }
  }, [assetId, selectedAssetIds]);

  return (
    <div
      key={item.assetId}
      data-testid="assets-list-card"
      className={cx('assets-list-card-wrapper', {
        'assets-list-card-wrapper--selected': isBulkSelected,
        'assets-list-card-wrapper--hovered': isHovered && isBulkSelected
      })}
      draggable
      onDragStart={handleDragStart}
      ref={wrapperRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        if (wrapperRef.current && wrapperRef.current.querySelector('.action-menu.is-open')) {
          return;
        }
        setIsHovered(false);
      }}>

      {isProjectBrief &&

      <div className="checkbox-project-brief">
          <Checkbox
          checked={checked}
          onChange={() => setChecked(!checked)} />

        </div>}


      {/* $FlowFixMe */}
      <List.CardItem
        className="asset-list-card"
        customCoverImage={<AssetPreview {...getAssetPreviewProps({ asset: item })} />}
        onClick={handleClick}>

        <div className="asset-list-card__info">
          <div className="asset-list-card__info__text">
            <Text heading5 className="asset-list-card__info__text__title" ellipsisOverflow>
              {title}
            </Text>
            <Text timestamp className="asset-list-card__info__text__timestamp">
              {`${createdByUser ? `${createdByUser.firstName} ${createdByUser.lastName}: ` : ''}${createdAt ? formatDate(createdAt, 'DD MMM YYYY') : ''}`}
            </Text>
          </div>
          <ActionPopup className="asset-list-card__actions" options={options} onClose={onMenuClose} />
        </div>
      </List.CardItem>
    </div>);

}

export default memo(AssetsListCard);